import React from "react";
import { Coins, Star } from "lucide-react";

export function OuroBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-gradient-to-r from-amber-400 to-amber-600 text-amber-950 shadow-md shadow-amber-500/40"
      data-testid="badge-destaque"
    >
      <Star size={11} fill="currentColor" /> Empresa Destaque
    </span>
  );
}

export function CashbackBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-emerald-100 text-emerald-800 border border-emerald-300"
      data-testid="badge-cashback"
    >
      <Coins size={12} /> BemCash
    </span>
  );
}

export function PlanPill({ plan }) {
  const map = {
    OURO:   "bg-amber-50 text-amber-800 border-amber-300",
    PRATA:  "bg-slate-100 text-slate-700 border-slate-300",
    BRONZE: "bg-orange-50 text-orange-800 border-orange-300",
    GRATIS: "bg-stone-100 text-stone-600 border-stone-300",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-semibold border ${map[plan] || map.GRATIS}`} data-testid={`plan-pill-${plan}`}>
      {plan}
    </span>
  );
}
